const TextBoxIcon = ({
  width,
  height,
}: {
  width?: string | number;
  height?: string | number;
}) => {
  return (
    <svg
      width={width||"29"}
      height={height||"28"}
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.25 3C5.17893 3 3.5 4.67893 3.5 6.75V21.25C3.5 23.3211 5.17893 25 7.25 25H14.9995C14.6527 24.5384 14.358 24.0355 14.1241 23.5H7.25C6.00736 23.5 5 22.4926 5 21.25V6.75C5 5.50736 6.00736 4.5 7.25 4.5H21.75C22.9926 4.5 24 5.50736 24 6.75V13.6241C24.5355 13.858 25.0384 14.1527 25.5 14.4995V6.75C25.5 4.67893 23.8211 3 21.75 3H7.25ZM13.5661 19.5C13.6352 18.9814 13.7573 18.4795 13.9268 18H9.25C8.83579 18 8.5 18.3358 8.5 18.75C8.5 19.1642 8.83579 19.5 9.25 19.5H13.5661ZM9.25 13C8.83579 13 8.5 13.3358 8.5 13.75C8.5 14.1642 8.83579 14.5 9.25 14.5H15.75C16.1642 14.5 16.5 14.1642 16.5 13.75C16.5 13.3358 16.1642 13 15.75 13H9.25ZM8.5 8.75C8.5 8.33579 8.83579 8 9.25 8H19.75C20.1642 8 20.5 8.33579 20.5 8.75C20.5 9.16421 20.1642 9.5 19.75 9.5H9.25C8.83579 9.5 8.5 9.16421 8.5 8.75ZM27.5 20.5C27.5 24.0899 24.5899 27 21 27C17.4101 27 14.5 24.0899 14.5 20.5C14.5 16.9101 17.4101 14 21 14C24.5899 14 27.5 16.9101 27.5 20.5ZM24.1464 17.6464L19.5 22.2929L17.8536 20.6464C17.6583 20.4512 17.3417 20.4512 17.1464 20.6464C16.9512 20.8417 16.9512 21.1583 17.1464 21.3536L19.1464 23.3536C19.3417 23.5488 19.6583 23.5488 19.8536 23.3536L24.8536 18.3536C25.0488 18.1583 25.0488 17.8417 24.8536 17.6464C24.6583 17.4512 24.3417 17.4512 24.1464 17.6464Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default TextBoxIcon;
